module.exports = __webpack_public_path__ + "static/media/more-theme-icon.37da4759.svg";